import React, { useState, useEffect, useCallback, memo } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import HorizontalScroll from 'react-scroll-horizontal'
import Alink from 'estimate_list/libs/alink'
import MiddlePage from 'estimate_list/components/layout/middle_page'
import Thumb from 'estimate_list/components/layout/thumb'
import Banner from 'estimate_list/components/layout/banner'
import { numberFormat, itemThumbUrl } from 'estimate_list/libs/util'

const ListEvent = ({ event }) => {
    const domain = useSelector(state => state.initial.domain)
    const selectCategory = useSelector(state => state.initial.selectCategory)
    const [eventList, setEventList] = useState(event)
    const [activeIndex, setActiveIndex] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [pageSize, setPageSize] = useState(1)
    const activeEvent = eventList[activeIndex]

    useEffect(() => {
        setEventList(event)
        setActiveIndex(0)
        setPageSize(1)
    }, [selectCategory, event])

    useEffect(() => {
        const activeEvent = eventList[activeIndex]
        if (!activeEvent) return
        if (activeEvent?.detail) {
            setPageSize(Math.ceil(activeEvent?.detail.length / 2))
        } else {
            setPageSize(1)
        }
        setCurrentPage(1)
    }, [activeEvent, setPageSize, setCurrentPage, activeIndex, eventList])

    const onClickArrow = useCallback(arrow => () => {
        if ((currentPage === 1 && arrow === 'prev') || (currentPage === pageSize && arrow === 'next')) {
            return
        }
        setCurrentPage(state => arrow === 'prev' ? state - 1 : state + 1)
    }, [currentPage, pageSize])

    const priceValue = (f_sellout, price, cnt_stock) => {
        if (f_sellout === 2 || f_sellout === 12) {
            return <span className="no_price">{domain === 'minishop' ? '-' : '단종된 상품'}</span>
        } else if (f_sellout === 1 || f_sellout === 11 || price === 0) {
            return <span className="no_price">{domain === 'minishop' ? '일시품절' : '가격비교예정'}</span>
        } else if  (cnt_stock === 0) {
            return <span className="no_price">일시품절</span>
        } else if (isPrice(f_sellout, price, cnt_stock)) {
            return <>
                <span>최저 </span>
                <span className="num">{numberFormat(price)}</span>
                <span>원</span>
            </>
        }
    }

    const isPrice = (f_sellout, price, cnt_stock) => {
        return f_sellout === 0 && cnt_stock > 0 && price !== 0
    }

    return (
        activeEvent && (
            <Style>
                <Tab>
                    <div className="logo">
                        <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/tit_hot_event.png`} alt="핫이벤트" />
                    </div>
                    <div className="tab_wrap">
                        {event.length > 8 ? (
                            <HorizontalScroll reverseScroll={true}>
                                {[
                                    <ul className="tab" key="tab">
                                        {event.map((v, i) => (
                                            <li key={i} className={activeIndex === i ? 'active' : ''}>
                                                <button type="button" onClick={() => setActiveIndex(i)}>
                                                    <Thumb src={v.img_s} alt={v.nm_evt} width={80} height={80} />
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                ]}
                            </HorizontalScroll>
                        ) : (
                            <ul className="tab">
                                {event.map((v, i) => (
                                    <li key={i} className={activeIndex === i ? 'active' : ''}>
                                        <button type="button" onClick={() => setActiveIndex(i)}>
                                            <Thumb src={v.img_s} alt={v.nm_evt} width={80} height={80} />
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </Tab>
                <Content>
                    <div className="top">
                        <div className="subject">
                            {activeEvent.nm_evt}
                            <Alink href={`${process.env.REACT_APP_EVENT_URL}/detail/${activeEvent.pr_idx}`} className="btn_event_more">
                                <i className="icon-add"></i> 더보기
                            </Alink>
                        </div>
                        <MiddlePage currentPage={currentPage} pageSize={pageSize} onClickArrow={onClickArrow} />
                    </div>
                    <div className="bottom">
                        <div className="img_field">
                            <Alink href={`${process.env.REACT_APP_EVENT_URL}/detail/${activeEvent.pr_idx}`} target="_blank">
                                <Banner src={activeEvent.img_b} alt={activeEvent.nm_evt} width={416} height={298} />
                            </Alink>
                        </div>
                        <div className="product_field">
                            {activeEvent?.detail?.map((v, i) => {
                                const page = currentPage - 1
                                const condition = i >= page * 2 && i < page * 2 + 2
                                const isAdult = v.cate_f_adult && !v.user_f_adult // 성인인증 썸네일 사용여부

                                return (
                                    condition && (
                                        <div className="product" key={v.item_id}>
                                            <div className="thumb">
                                                <Alink href={v.link} target={'_blank'}>
                                                    <Thumb
                                                        src={itemThumbUrl(v.item_id, 200)}
                                                        alt={v.item_name}
                                                        width={198}
                                                        height={198}
                                                        isAdult={isAdult}
                                                    />
                                                </Alink>
                                            </div>
                                                <Alink href={v.link} className="name" target={'_blank'}>
                                                    {/*이벤트 full_item_name 추정 지역*/}
                                                    {/*추후 작업해야함*/}
                                                    {v.full_item_name}
                                                </Alink>
                                                    <div className="price">
                                                        {priceValue(0, v.price, 999)}
                                                    </div>
                                            {/* <div className="price">최저<strong>{v.price}</strong>원</div> */}
                                        </div>
                                    )
                                )
                            })}
                        </div>
                    </div>
                </Content>
            </Style>
        )
    )
}

const Style = styled.div`
    margin: 30px 0 0
`
const Tab = styled.div`
    position: relative;
    display: flex;
    padding: 10px 0 0 0;
    border: 1px solid #ccc;
    border-bottom: 1px solid #418ded;
    background: #f0eff5;

    .logo {
        padding: 5px 90px 0 20px;
    }
    .tab_wrap {
        position: relative;
        top: 1px;
        width: calc(100% - 239px);
        height: 82px;
    }
    .tab {
        display: flex;

        li {
            position: relative;
            width: 82px;
            height: 82px;
            border: 1px solid #ccc;
            border-bottom: 1px solid #418ded;

            &:last-child {
                margin-right: 1px;
            }
            & + li {
                margin: 0 0 0 -1px
            }
            &.active {
                z-index: 10;
                border-color: #418ded;
                border-bottom: 1px solid #fff
            }
        }
    }
`
const Content = styled.div`
    border: 1px solid #418ded;
    border-top: 0;
    padding: 30px 20px;

    .top {
        display: flex;
        justify-content: space-between;
        margin: 0 0 20px;

        .subject {
            padding: 0 10px 0 0;
            font-size: 28px;
            font-weight: 700;

            a {
                display: inline-block;
                vertical-align: top;
                margin: 8px 0 0 10px;
                color: #418ded;
                font-size: 12px;
                font-weight: 400;

                i {
                    font-weight: 700
                }
            }
        }
    }
    .bottom {
        display: flex;
    }
    .product_field {
        display: flex;

        .product {
            margin: 0 0 0 16px;
            width: 200px;
            display: flex;
            flex-direction: column;

            &:hover {
                .thumb {
                    border-color: #418ded
                }
            }
            .thumb {
                border: 1px solid #efeff3
            }
            .name {
                margin: 5px 0 0;
                height: 36px;
                line-height: 18px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .price {
                margin: 8px 0px 0px;
                display: inline-block;
                vertical-align: middle;
                font-size: 14px;
                line-height: 18px;
                text-align: right;

                span {
                    color: #999;
                }
                .no_price {
                    font-size: 20px;
                    font-weight: 700;
                }
                .num {
                    margin: 0px 1px 0px 1px;
                    font-size: 20px;
                    font-weight: 700;
                    color: #f24443;
                }
            }
        }
    }
    .img_field {
        width: 416px;
        height: 298px;

        & > a {
            display: block;
        }
    }
`

export default memo(ListEvent)



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/list_event.js